import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/classPrivateFieldLooseKey";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _cancellation;
var _excluded = ["limit", "after"],
  _excluded2 = ["fetchItems", "memoizeInitial"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import memoize from 'memoizee';
import { action, computed, observable, runInAction } from 'mobx';
import { task } from 'mobx-task';
import { Cancellation, createCancellationTokenSource } from '../utils/cancellation';
var InfiniteScrollProvider = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = task.resolved, _dec6 = task.resolved, _class = (_cancellation = /*#__PURE__*/_classPrivateFieldLooseKey("cancellation"), /*#__PURE__*/function () {
  function InfiniteScrollProvider(_ref2) {
    var fetchItems = _ref2.fetchItems,
      memoizeInitial = _ref2.memoizeInitial,
      opts = _objectWithoutProperties(_ref2, _excluded2);
    _classCallCheck(this, InfiniteScrollProvider);
    _initializerDefineProperty(this, "isDone", _descriptor, this);
    _initializerDefineProperty(this, "cursor", _descriptor2, this);
    _initializerDefineProperty(this, "limit", _descriptor3, this);
    _initializerDefineProperty(this, "items", _descriptor4, this);
    Object.defineProperty(this, _cancellation, {
      writable: true,
      value: createCancellationTokenSource()
    });
    Object.assign(this, opts);
    this._fetchItems = fetchItems;
    this.fetch = this.fetch.bind(this);
    this.more = this.more.bind(this);
    if (memoizeInitial) {
      this.fetch = this.fetch.wrap(function (fn) {
        return memoize(fn, {
          promise: true
        });
      });
    }
  }
  return _createClass(InfiniteScrollProvider, [{
    key: "active",
    get: function get() {
      return this.fetch.resolved && this.more.resolved && !this.isDone;
    }
  }, {
    key: "removeItem",
    value: function removeItem(item) {
      this.items.remove(item);
    }

    /**
     * Resets the paging state and fetch cache (unless `soft` is `true`)
     * @param {Boolean} soft If true, does not clear the initial fetch cache.
     */
  }, {
    key: "reset",
    value: function reset(soft) {
      this.isDone = false;
      this.cursor = null;
      this.items = [];
      if (this.fetch.clear && !soft) {
        this.fetch.clear();
      }
    }
  }, {
    key: "done",
    value: function done() {
      this.isDone = true;
    }
  }, {
    key: "setCursor",
    value: function setCursor(cursor) {
      this.cursor = cursor;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.reset(true);
              return _context2.abrupt("return", this.more());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetch() {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "more",
    value: function () {
      var _more = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var promise, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _classPrivateFieldLooseBase(this, _cancellation)[_cancellation].cancel();
              _classPrivateFieldLooseBase(this, _cancellation)[_cancellation] = createCancellationTokenSource();
              promise = this._promise = this.invokeFetchItems(_classPrivateFieldLooseBase(this, _cancellation)[_cancellation].token);
              _context3.next = 5;
              return promise;
            case 5:
              result = _context3.sent;
              if (!(promise !== this._promise)) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return", null);
            case 8:
              if (result) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return", null);
            case 10:
              if (result.cursor) {
                _context3.next = 13;
                break;
              }
              this.done();
              return _context3.abrupt("return", result);
            case 13:
              this.setCursor(result.cursor);
              return _context3.abrupt("return", result);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function more() {
        return _more.apply(this, arguments);
      }
      return more;
    }()
  }, {
    key: "invokeFetchItems",
    value: function invokeFetchItems(token) {
      var _this = this;
      return this._fetchItems({
        limit: this.limit,
        after: this.cursor ? this.cursor : undefined
      }).then(function (result) {
        token.throwIfCancelled();
        runInAction(function () {
          if (!_this.cursor) {
            _this.items = [];
          }
          if (result.data && Array.isArray(result.data)) {
            var _this$items;
            (_this$items = _this.items).push.apply(_this$items, _toConsumableArray(result.data));
          }
        });
        return result;
      }).catch(function (err) {
        if (err instanceof Cancellation) {
          return {
            data: [],
            cursor: null,
            total: 0
          };
        }
        throw err;
      });
    }
  }]);
}()), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isDone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cursor", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "limit", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 10;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "items", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeItem", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "removeItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "done", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "done"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCursor", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "setCursor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetch", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "fetch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "more", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "more"), _class.prototype), _class);
export { InfiniteScrollProvider as default };
/**
 * This converts the limit + after-style fetchItems to one using limit + skip.
 */
export function usingSkipLimit(fetchItems) {
  return /*#__PURE__*/function () {
    var _fetcher = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var limit, _ref$after, after, params, result, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            limit = _ref.limit, _ref$after = _ref.after, after = _ref$after === void 0 ? 0 : _ref$after, params = _objectWithoutProperties(_ref, _excluded);
            _context.next = 3;
            return fetchItems({
              limit: limit,
              skip: after
            });
          case 3:
            result = _context.sent;
            data = Array.isArray(result) ? result : result.data;
            return _context.abrupt("return", {
              data: data,
              cursor: data.length === 0 ? null : limit + after
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetcher(_x) {
      return _fetcher.apply(this, arguments);
    }
    return fetcher;
  }();
}
//# sourceMappingURL=InfiniteScrollProvider.js.map
